import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15 5a1 1 0 1 0 2 0a1 1 0 1 0 -2 0","key":"svg-0"}],["path",{"d":"M5 20l5 -.5l1 -2","key":"svg-1"}],["path",{"d":"M18 20v-5h-5.5l2.5 -6.5l-5.5 1l1.5 2","key":"svg-2"}]]

const IconStretching = createReactComponent('outline', 'stretching', 'Stretching', __iconNode);

export default IconStretching;